module.exports = __webpack_public_path__ + "tc.4a66d0f056058298ae71.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/node_modules/flag-icon-css/flags/4x3/tc.svg
// module id = ../../../../flag-icon-css/flags/4x3/tc.svg
// module chunks = styles